module.exports = __webpack_public_path__ + "static/media/spotting-ON.8faf712c.png";